const maxSizeMb = 5;

export const checkFileSize = (file: File): Boolean => {
	return (file.size / 1024 / 1024) > maxSizeMb;
}
